module.exports = __webpack_public_path__ + "static/img/img4.8f31d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img4.png
// module id = MKzk
// module chunks = 23